export default {
  ARROW_DOWN: 40,
  ARROW_UP: 38,
  SPACE: 32,
  ENTER: 13,
  ESC: 27,
  TAB: 9
};
